module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-door-vertical-side.e6a3870f.png";